module.exports = __webpack_public_path__ + "img/Award.73df93fb.jpg";